import { render, staticRenderFns } from "./TreeSon.vue?vue&type=template&id=9ad040a8&scoped=true&"
import script from "./TreeSon.vue?vue&type=script&lang=js&"
export * from "./TreeSon.vue?vue&type=script&lang=js&"
import style0 from "./TreeSon.vue?vue&type=style&index=0&id=9ad040a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad040a8",
  null
  
)

export default component.exports